import { Logo } from "./Logo";

const columns = [
  {
    title: "Produit",
    links: [
      { label: "Fonctionnalités", href: "/#fonctionnalites" },
      { label: "Comment ça marche", href: "/#comment-ca-marche" },
      { label: "Rendez-vous", href: "/#rdv" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Instituts de beauté", href: "/#temoignages" },
      { label: "Coiffeurs", href: "/#temoignages" },
      { label: "Épiceries", href: "/#temoignages" },
      { label: "Restauration rapide", href: "/#temoignages" },
    ],
  },
  {
    title: "Entreprise",
    links: [
      { label: "À propos", href: "/#top" },
      { label: "Cas d'usage", href: "/#temoignages" },
    ],
  },
  {
    title: "Ressources",
    links: [
      { label: "Découvrir les commerces", href: "/decouvrir" },
      { label: "Nouveautés", href: "/nouveautes" },
      { label: "Mentions légales", href: "/mentions-legales" },
      { label: "Confidentialité", href: "/confidentialite" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="bg-cream px-6 pb-10 pt-20 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-8 border-b border-line pb-14 sm:flex-row sm:items-center">
          <h3 className="text-3xl font-extrabold tracking-tight text-ink lg:text-4xl">
            Digitalisez votre{" "}
            <span className="rounded-lg bg-ink px-2 py-1 text-white">fidélité client</span>.
          </h3>
          <a
            href="/#demo"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-gradient-brand px-7 py-3.5 text-sm font-semibold text-white shadow-soft transition-transform hover:scale-[1.03]"
          >
            Réserver une démo →
          </a>
        </div>

        <div className="grid grid-cols-2 gap-10 py-14 sm:grid-cols-4">
          {columns.map((col) => (
            <div key={col.title}>
              <p className="text-sm font-bold text-ink">{col.title}</p>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-ink-soft transition-colors hover:text-ink"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-line pt-10">
          <Logo />
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 text-sm text-ink-soft sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Wara Cards. Pensé, conçu et opéré en France.</p>
          <div className="flex gap-6">
            <a href="mailto:contact@fidelo.com" className="hover:text-ink">
              contact@fidelo.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
